export enum BurnModeType {
  Burnable = 0,
  NonBurnable = 1,
}

export enum EventsModeType {
  NoEvents = 0,
  CEP47 = 1,
  CES = 2,
}

export const BurnModeValueType = {
  [BurnModeType.Burnable]: 'Burnable',
  [BurnModeType.NonBurnable]: 'NonBurnable',
};

export const BurnModeTooltipType = {
  [BurnModeType.Burnable]: 'Minted tokens can be burned.',
  [BurnModeType.NonBurnable]: 'Minted tokens cannot be burned.',
};

export const EventsModeValueType = {
  [EventsModeType.NoEvents]: 'No events',
  [EventsModeType.CEP47]: 'CEP-47 style Map-based events',
  [EventsModeType.CES]: 'Casper Event Standard (CES)',
};

export const EventsModeTooltipType = {
  [EventsModeType.NoEvents]:
    'This modality will signal the contract to not record events at all. This is the default mode.',
  [EventsModeType.CEP47]:
    'This modality will signal the contract to record events using the CEP47 event schema',
  [EventsModeType.CES]:
    'This modality will signal the contract to record events using the Casper Event Standard',
};

export enum HolderModeType {
  Accounts = 0,
  Contracts = 1,
  Mixed = 2,
}

export const HolderModeValueType = {
  [HolderModeType.Accounts]: 'Accounts',
  [HolderModeType.Contracts]: 'Contracts',
  [HolderModeType.Mixed]: 'Mixed',
};

export const HolderModeTooltipType = {
  [HolderModeType.Accounts]:
    'In this mode, only Accounts can own and mint NFTs.',
  [HolderModeType.Contracts]:
    'In this mode, only Contracts can own and mint NFTs.',
  [HolderModeType.Mixed]:
    'In this mode both Accounts and Contracts can own and mint NFTs.',
};

export enum IdentifierModeType {
  Ordinal = 0,
  Hash = 1,
}

export const IdentifierModeValueType = {
  [IdentifierModeType.Ordinal]: 'Ordinal',
  [IdentifierModeType.Hash]: 'Hash',
};

export const IdentifierModeTooltipType = {
  [IdentifierModeType.Ordinal]:
    'NFTs minted in this modality are identified by a u64 value. This value is determined by the number of NFTs minted by the contract at the time the NFT is minted.',
  [IdentifierModeType.Hash]:
    'NFTs minted in this modality are identified by a base16 encoded representation of the blake2b hash of the metadata provided at the time of mint.',
};

export enum MetadataMutabilityType {
  Immutable = 0,
  Mutable = 1,
}

export const MetadataMutabilityValueType = {
  [MetadataMutabilityType.Immutable]: 'Immutable',
  [MetadataMutabilityType.Mutable]: 'Mutable',
};

export const MetadataMutabilityTooltipType = {
  [MetadataMutabilityType.Immutable]:
    'Metadata for NFTs minted in this mode cannot be updated once the NFT has been minted.',
  [MetadataMutabilityType.Mutable]:
    'Metadata for NFTs minted in this mode can update the metadata via the set_token_metadata entrypoint.',
};

export enum MintingModeType {
  Installer = 0,
  Public = 1,
}

export const MintingModeValueType = {
  [MintingModeType.Installer]: 'Installer',
  [MintingModeType.Public]: 'Public',
};

export const MintingModeTooltipType = {
  [MintingModeType.Installer]:
    'This mode restricts the ability to mint new NFT tokens only to the installing account of the NFT contract.',
  [MintingModeType.Public]: 'This mode allows any account to mint NFT tokens.',
};

export enum NFTKindType {
  Physical = 0,
  Digital = 1,
  Virtual = 2,
}

export const NFTKindValueType = {
  [NFTKindType.Physical]: 'Physical',
  [NFTKindType.Digital]: 'Digital',
  [NFTKindType.Virtual]: 'Virtual',
};

export const NFTKindTooltipType = {
  [NFTKindType.Physical]:
    'The NFT represents a real-world physical item e.g., a house.',
  [NFTKindType.Digital]:
    'The NFT represents a digital item, e.g., a unique JPEG or digital art.',
  [NFTKindType.Virtual]:
    'The NFT is the virtual representation of a physical notion, e.g., a patent or copyright.',
};

export enum NFTMetadataKindType {
  CEP78 = 0,
  NFT721 = 1,
  Raw = 2,
  CustomValidated = 3,
}

export const NFTMetadataKindValueType = {
  [NFTMetadataKindType.CEP78]: 'CEP78',
  [NFTMetadataKindType.NFT721]: 'NFT721',
  [NFTMetadataKindType.Raw]: 'Raw',
  [NFTMetadataKindType.CustomValidated]: 'CustomValidated',
};

export const NFTMetadataKindTooltipType = {
  [NFTMetadataKindType.CEP78]:
    'This mode specifies that NFTs minted must have valid metadata conforming to the CEP-78 schema.',
  [NFTMetadataKindType.NFT721]:
    'This mode specifies that NFTs minted must have valid metadata conforming to the NFT-721 metadata schema.',
  [NFTMetadataKindType.Raw]:
    'This mode specifies that metadata validation will not occur and raw strings can be passed to token_metadata runtime argument as part of the call to mint entrypoint.',
  [NFTMetadataKindType.CustomValidated]:
    'This mode specifies that a custom schema provided at the time of install will be used when validating the metadata as part of the call to mint entrypoint.',
};

export enum OwnershipModeType {
  Minter = 0,
  Assigned = 1,
  Transferable = 2,
}

export const OwnershipModeValueType = {
  [OwnershipModeType.Minter]: 'Minter',
  [OwnershipModeType.Assigned]: 'Assigned',
  [OwnershipModeType.Transferable]: 'Transferable',
};

export const OwnershipModeTooltipType = {
  [OwnershipModeType.Minter]:
    'Minter mode is where the ownership of the newly minted NFT is attributed to the minter of the NFT and cannot be specified by the minter. In the Minter mode the owner of the NFT will not change and thus cannot be transferred to another entity.',
  [OwnershipModeType.Assigned]:
    'Assigned mode is where the owner of the newly minted NFT must be specified by the minter of the NFT. In this mode, the assigned entity can be either minter themselves or a separate entity. However, similar to the Minter mode, the ownership in this mode cannot be changed, and NFTs minted in this mode cannot be transferred from one entity to another.',
  [OwnershipModeType.Transferable]:
    'In the Transferable mode the owner of the newly minted NFT must be specified by the minter. However, in the Transferable mode, NFTs can be transferred from the owner to another entity.',
};

export enum WhitelistModeType {
  Unlocked = 0,
  Locked = 1,
}

export const WhitelistModeValueType = {
  [WhitelistModeType.Unlocked]: 'Unlocked',
  [WhitelistModeType.Locked]: 'Locked',
};

export const WhitelistModeTooltipType = {
  [WhitelistModeType.Unlocked]:
    'The contract whitelist is unlocked and can be updated via the set variables endpoint.',
  [WhitelistModeType.Locked]:
    'The contract whitelist is locked and cannot be updated further.',
};

export enum OwnerReverseLookupModeType {
  NoLookup = 0,
  Complete = 1,
  TransfersOnly = 2,
}

export const OwnerReverseLookupModeValueType = {
  [OwnerReverseLookupModeType.NoLookup]: 'NoLookup',
  [OwnerReverseLookupModeType.Complete]: 'Complete',
  [OwnerReverseLookupModeType.TransfersOnly]: 'TransfersOnly',
};

export const OwnerReverseLookupModeTooltipType = {
  [OwnerReverseLookupModeType.NoLookup]:
    'The reporting and receipt functionality is not supported. In this option, the contract instance does not maintain a reverse lookup database of ownership and therefore has more predictable gas costs and greater scaling.',
  [OwnerReverseLookupModeType.Complete]:
    'The reporting and receipt functionality is supported. Token ownership will be tracked by the contract instance using the system.',
  [OwnerReverseLookupModeType.TransfersOnly]:
    "The reporting and receipt functionality is supported alike Complete however it is not directly active after minting but only after a first transfer. This modality is for usecases where the majority of NFTs are owned by a private minter and only NFT's that have been transferred benefit from reverse lookup tracking. Token ownership will be as well tracked by the contract instance using the system.",
};
